module.exports = __webpack_public_path__ + "h5/img/ava1 (5).dde424ab.png";